import { computed, ref, type Ref } from 'vue'
import { defineStore } from 'pinia'
import router from '@/plugins/router'
import type { User } from '@/models/User'

export const useUserStore = defineStore(
  'user',
  () => {
    const authenticatedUser: Ref<User | null> = ref(null)
    const isAuthenticated = computed(() => authenticatedUser.value != null)

    const login = (user: User) => {
      authenticatedUser.value = user
    }

    const logout = () => {
      authenticatedUser.value = null
      router.push({ name: 'login' })
    }

    return { authenticatedUser, isAuthenticated, login, logout }
  },
  {
    persist: true,
  },
)
